import {uint8ArrayToBase64} from '../../../utils/arrayUtils';

export default function workspaceIdToParam(workspaceId?: Uint8Array | null): string {
  return encodeURIComponent(uint8ArrayToBase64(workspaceId));
}